import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaddingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"padding"}/>
}
